import { createSeparator } from './helper/separator';
export const itemDefaultSize = 20;

const extractWebLoadsToList = state => (loads, headers) => {
  let stops = [];
  loads.forEach((loadItem, index) => {
    stops.push(loadItem);
    loadItem.pickStop.forEach(pickStop => {
      stops.push(pickStop);
    });
    stops.push(loadItem.dropLoad);
    loadItem.dropStop.forEach(dropStop => {
      stops.push(dropStop);
    });
    stops.push(createSeparator(headers, 'load', index, loadItem.rowState.id));
  });

  return stops;
};

const createWebLoadArray = state => (loadsData, headers, pageName) => {
  const loads = [];
  loadsData.forEach(load => loads.push(createWebLoad(load, headers, pageName)));
  return loads;
};

export const updateOrdersLoadState = (state, loads, total, pageName = 'pastLoads', hasError = false, message = '') => ({
  ...state,
  ...{
    loads,
    loading: false,
    hasError,
    message,
    total: total,
    pageName: pageName,
    loadsAssignedStops: extractWebLoadsToList(state)(createWebLoadArray(state)(loads, state.headers, pageName), state.headers),
  },
});

export const loadContent = (state, responseData, hasError = false, message = '') => {
  const { response, pageName } = responseData;
  const data = response.data || [];
  return updateOrdersLoadState(state, data.data, data.total, pageName, hasError, message);
};

export const createWebLoad = (loadData, headers, pageName) => {
  const loadWebData = {
    row: [],
    pageName: pageName,
    pickStop: [],
    dropStop: [],
    dropLoad: createDropLoad(loadData, headers),
    rowState: {
      type: 'load',
      id: loadData.loadId,
      loadData,
      visible: true,
      height: itemDefaultSize,
    },
  };

  loadData.pickStop.forEach((stop, i) => loadWebData.pickStop.push(createStop(stop, headers, loadData, 'pick', i, pageName)));
  loadData.dropStop.forEach((stop, i) => loadWebData.dropStop.push(createStop(stop, headers, loadData, 'drop', i, pageName)));

  for (let hederIndex = 0; hederIndex < headers.length; hederIndex++) {
    const headerItem = headers[hederIndex];
    let value = null;
    let fieldType = 'text';
    let editable = false;
    let cellStyle = {};
    let tooltip = null;
    if (!headerItem.leftAction) {
      switch (headerItem.key) {
        case 'flag':
          value = loadData.workingUser;
          fieldType = 'flag';
          break;
        case 'loadNumber':
          value = loadData.loadNumber;
          fieldType = 'text';
          break;
        case 'status':
          value = loadData.pickStopStatus;
          fieldType = 'select';
          editable = true;
          break;
        case 'notes':
          value = loadData.loadPickStopCommentsCount;
          fieldType = 'text';
          break;
        case 'pickAppointment':
          value = 'Pick APPT';
          fieldType = 'text';
          break;
        case 'checkIn':
          value = 'Pick In';
          fieldType = 'text';
          break;
        case 'checkOut':
          value = 'Pick Out';
          fieldType = 'text';
          break;
        case 'warehouses':
          value = 'Pick Location';
          fieldType = 'text';
          break;
        case 'sequence':
          value = 'Seq';
          fieldType = 'integer';
          break;
        default:
          break;
      }
    } else {
      value = '';
      fieldType = 'text';
    }

    loadWebData.row.push({
      key: headerItem.key,
      value,
      fieldType,
      displayState: 1,
      editable,
      cellStyle,
      tooltip,
    });
  }

  return loadWebData;
};

export const createDropLoad = (load, headers) => {
  const dropLoadData = {
    row: [],
    rowState: {
      type: 'dropLoad',
      id: load.loadId,
      loadData: load,
      visible: true,
      height: itemDefaultSize,
    },
  };

  for (let hederIndex = 0; hederIndex < headers.length; hederIndex++) {
    const headerItem = headers[hederIndex];
    let value = null;
    let editable = false;
    let fieldType = 'text';
    if (!headerItem.leftAction) {
      switch (headerItem.key) {
        case 'loadNumber':
          value = load.loadNumber;
          fieldType = 'text';
          break;
        case 'status':
          value = load.dropStopStatus;
          fieldType = 'select';
          editable = true;
          break;
        case 'notes':
          value = load.loadDropStopCommentsCount;
          fieldType = 'text';
          break;
        case 'pickAppointment':
          value = 'Drop APPT';
          fieldType = 'text';
          break;
        case 'checkIn':
          value = 'Drop In';
          fieldType = 'text';
          break;
        case 'checkOut':
          value = 'Drop Out';
          fieldType = 'text';
          break;
        case 'warehouses':
          value = 'Drop Location';
          fieldType = 'text';
          break;
        case 'sequence':
          value = 'Seq';
          fieldType = 'integer';
          break;
        case 'actions':
          value = 'Delivered';
          fieldType = 'actions';
          break;
        default:
          break;
      }
    } else {
      value = '';
      fieldType = 'text';
    }

    dropLoadData.row.push({
      key: headerItem.key,
      value,
      fieldType,
      displayState: 1,
      editable,
    });
  }

  return dropLoadData;
};

export const createStop = (stop, headers, loadData, stopType, i, pageName) => {
  const stopData = {
    row: [],
    rowState: {
      type: 'stop',
      loadType: stopType === 'pick' ? 'pickLoad' : 'dropLoad',
      stopData: stop,
      loadId: loadData.loadId,
      visible: true,
      height: itemDefaultSize,
    },
  };

  for (let hederIndex = 0; hederIndex < headers.length; hederIndex++) {
    const headerItem = headers[hederIndex];
    let value = null;
    let value2 = null;
    let fieldType = 'text';
    let editable = false;
    let cellStyle = {};
    let tooltip = null;
    if (!headerItem.leftAction) {
      switch (headerItem.key) {
        case 'number':
          value = i + 1;
          fieldType = 'integer';
          break;
        case 'loadNumber':
          value = loadData.loadNumber;
          fieldType = 'text';
          break;
        case 'status':
          value = stopType === 'pick' ? stop.pickStopStatus : stop.dropStopStatus;
          fieldType = 'select';
          editable = true;
          break;
        case 'notes':
          value = stop.stopNoteCount;
          fieldType = 'text';
          break;
        case 'pickAppointment':
          value = stop.appointment;
          fieldType = 'dateTime';
          editable = false;
          break;
        case 'checkIn':
          value = stop.pickIn;
          value = stopType === 'pick' ? stop.pickIn : stop.dropIn;
          fieldType = 'dateTime';
          editable = true;
          break;
        case 'checkOut':
          value = stop.pickOut;
          value = stopType === 'pick' ? stop.pickOut : stop.dropOut;
          fieldType = 'dateTime';
          editable = true;
          break;
        case 'warehouses':
          value = stop.locationName;
          fieldType = 'text';
          break;
        case 'sequence':
          value = stop.sequence;
          fieldType = 'integer';
          break;
        default:
          break;
      }
    } else {
      value = '';
      fieldType = 'text';
    }

    stopData.row.push({
      key: headerItem.key,
      value,
      value2,
      fieldType,
      displayState: 1,
      editable,
      cellStyle,
      tooltip,
    });
  }

  return stopData;
};

export const setHeaderWidth = (state, ind, width) => {
  const header = state.headers[ind];
  header.width = width;
  return {
    ...state,
    ...{
      headers: [...state.headers.slice(0, ind), ...[header], ...state.headers.slice(ind + 1)],
      stops: state.loadsAssignedStops,
    },
  };
};

export const filterCallCheckLoads = (state, data) => {
  const { filterType, option } = data;
  const stateFilterOptions = JSON.parse(JSON.stringify(state.filterOptions));
  Object.keys(stateFilterOptions).forEach(key => {
    if (key === filterType) {
      stateFilterOptions[key] = option;
    } else if (filterType === 'default' && key !== 'searchText') {
      stateFilterOptions[key] = null;
    }
  });

  return {
    ...state,
    ...{
      filterOptions: stateFilterOptions,
    },
  };
};

export const callCheckLoadsPagination = (state, data) => {
  const { filterType, option } = data;
  const statePagination = JSON.parse(JSON.stringify(state.pagination));
  Object.keys(statePagination).forEach(key => {
    if (key === filterType) {
      statePagination[key] = option;
    } else if (filterType === 'default') {
      statePagination[key] = null;
    }
  });

  return {
    ...state,
    ...{
      pagination: statePagination,
    },
  };
};

export const getLoadNotes = (state, response, hasError = false, message = '') => {
  const data = response.data || [];
  return {
    ...state,
    ...{
      loadNotes: data,
      notesLoading: false,
      hasError,
      message,
    },
  };
};

export const getStopNotes = (state, response, hasError = false, message = '') => {
  const data = response.data || [];
  return {
    ...state,
    ...{
      stopNotes: data,
      notesLoading: false,
      hasError,
      message,
    },
  };
};

// export const setStopNotes = (state, note) => {
//   return {
//     ...state,
//     stopNotes: {
//       ...state.stopNotes,
//       data: [...state.stopNotes.data, note.data],
//     },
//     notesLoading: false,
//   };
// };

export const setEmptyAllNotes = (state) => {
  return {
    ...state,
    loadNotes: [],
    stopNotes: [],
    orderNotes: [],
    notesLoading: false,
  };
};

export const setCurrentUser = (state, data) => {
  const newLoads = [...state.loads];
  const currentLoad = newLoads.find(load => load?.loadId === data?.rowState?.id);
  currentLoad.workingUser = currentLoad.workingUser ? null : data.value;
  return updateOrdersLoadState(state, newLoads, state.total, '', state.hasError, state.message);
};

export const setCallCheckLoadLoadsStatus = (state, data) => {
  if (data.rowState.id) {
    const newLoads = [...state.loads];
    const currentLoad = newLoads.find(load => load?.loadId === data?.rowState?.id);

    if (data.rowState.type === 'load') {
      currentLoad.pickStopStatus = data.value;
    } else if (data.rowState.type === 'dropLoad') {
      currentLoad.dropStopStatus = data.value;
    }

    return updateOrdersLoadState(state, newLoads, state.total, '', state.hasError, state.message);
  } else {
    return state;
  }
};

export const setCallCheckLoadStopsStatus = (state, data) => {
  if (data.rowState.loadId) {
    const newLoads = [...state.loads];
    const currentLoad = newLoads.find(load => load?.loadId === data?.rowState?.loadId);
    const orderId = data.rowState.stopData?.orderIds?.[0] || data.rowState.stopData?.subOrderIds?.[0];

    if (data.rowState.type === 'stop') {
      if (data?.rowState.loadType === 'pickLoad') {
        currentLoad.pickStop.forEach(stop => {
          if (stop.orderIds?.includes(orderId)) {
            stop.pickStopStatus = data.value;
          }
          if (stop.subOrderIds?.includes(orderId)) {
            stop.pickStopStatus = data.value;
          }
        });
      } else if (data?.rowState.loadType === 'dropLoad') {
        currentLoad.dropStop.forEach(stop => {
          if (stop.orderIds?.includes(orderId)) {
            stop.dropStopStatus = data.value;
          }
          if (stop.subOrderIds?.includes(orderId)) {
            stop.dropStopStatus = data.value;
          }
        });
      }
    }

    return updateOrdersLoadState(state, newLoads, state.total, '', state.hasError, state.message);
  } else {
    return state;
  }
};

export const setCallCheckLoadsStopSDate = (state, data) => {
  const { rowState, value, header } = data;

  if (rowState.loadId) {
    const newLoads = [...state.loads];
    const currentLoad = newLoads.find(load => load?.loadId === rowState?.loadId);
    const orderId = rowState.stopData?.orderIds?.[0] || rowState.stopData?.subOrderIds?.[0];

    if (rowState.type === 'stop') {
      if (rowState.loadType === 'pickLoad') {
        currentLoad.pickStop.forEach(stop => {
          if (stop.orderIds?.includes(orderId)) {
            if (header.key === 'checkIn') {
              stop.pickIn = value;
            } else {
              stop.pickOut = value;
            }
          }
        });
      } else if (rowState.loadType === 'dropLoad') {
        currentLoad.dropStop.forEach(stop => {
          if (stop.orderIds?.includes(orderId)) {
            if (header.key === 'checkIn') {
              stop.dropIn = value;
            } else {
              stop.dropOut = value;
            }
          }
        });
      }
    }

    return updateOrdersLoadState(state, newLoads, state.total, '', state.hasError, state.message);
  } else {
    return state;
  }
};

// export const setDisplayState = (state, rowState, header, enable) => ({
//   ...state,
//   ...{
//     lastSelected: {
//       id: rowState.loadId,
//       headerKey: header.key,
//       enable: enable,
//     },
//   },
// });

export const setError = (state, err) => ({
  ...state,
  ...{
    hasError: true,
    message: err ? err : 'Something went wrong, please try again',
  },
});

export const resetError = state => ({
  ...state,
  ...{
    hasError: false,
    notesLoading: false,
    message: '',
  },
});

export const setInLoading = state => ({
  ...state,
  ...{
    loading: true,
  },
});

export const setInLoadingNotes = state => ({
  ...state,
  ...{
    notesLoading: true,
  },
});

export const setInLoadingCurrentUser = state => ({
  ...state,
  ...{
    loading: true,
  },
});

